import React, { createContext } from 'react'

import { serverSideQuery, useQuery } from '@/api'
import { DEFAULT_CONTEXT_VALUES, RELATED_PERFORMERS_ENDPOINT } from '@/constants'
import type {
    PerformerContextType,
    PerformerDataType,
    PerformerParams,
    PerformerProviderProps,
    PerformerStateType,
} from '@/context/performer/types'

import { relatedPerformerLinksSelector, relatedPerformersSelector } from './selectors'

const context = createContext<PerformerContextType>(DEFAULT_CONTEXT_VALUES)
const { Provider } = context

export const RelatedArtistsProvider: React.FC<PerformerProviderProps> = ({
    children,
    initialParams,
    initialProps,
    enabled,
}) => {
    const { fetching, data, error } = useQuery<PerformerDataType>({
        endpoint: RELATED_PERFORMERS_ENDPOINT,
        params: initialParams,
        initialFetchDisabled: !!initialProps?.data,
        initialData: initialProps?.data,
        enabled,
    })

    const state: PerformerStateType = { fetching, data, error }

    return (
        <Provider
            value={{
                state,
                selectors: [relatedPerformersSelector(state), relatedPerformerLinksSelector(state), initialParams],
            }}
        >
            {children}
        </Provider>
    )
}

export const serverSideRead = async (params: PerformerParams): Promise<PerformerDataType> => {
    const queryInstance = serverSideQuery<PerformerDataType>(RELATED_PERFORMERS_ENDPOINT)
    return queryInstance(params)
}

export default context
